const useTour = () => {
  return window.theme;
};

export default useTour;
